// Single source of truth for Divisions and Jobs (from the client's Job Card document).
// Job codes repeat across divisions (e.g. M1), so a job is identified by division + code.

export const OTHER_JOB = "Other";

export const DIVISIONS = [
  {
    name: "Sales",
    workCardUrl: null,
    jobs: [],
  },
  {
    name: "Client Delivery and Operations",
    workCardUrl: "https://drive.google.com/file/d/1GrgBNe_lnxjk4b_Vy4T1Vy1jvgfphyZ3/view?usp=drivesdk",
    jobs: [
      "O1 - Onboard a new client",
      "O2 - Hand over the divisional scopes",
      "O3 - Track the month",
      "O4 - Chase a delay or a missing input",
      "O5 - Weekly client update",
      "O6 - Monthly client report",
      "O7 - Monthly workflow check",
      "O8 - Before new work is agreed with a client",
      "O9 - A client is leaving",
      "M1 - Starting a new month for an existing client",
      "M2 - The client changes scope mid-month",
      "M3 - The weekly client call",
      "M4 - Keeping the delivery dashboard",
      "R1 - Your weekly and monthly report (for division leads & project leads)",
    ],
  },
  {
    name: "People and Culture",
    workCardUrl: null,
    jobs: [],
  },
  {
    name: "Growth Systems",
    workCardUrl: "https://drive.google.com/file/d/1k2VegY7EF86dT1aXAxJpsp_tfJd_GLEk/view?usp=drivesdk",
    jobs: [
      "G1 - Blog post",
      "G2 - SEO audit",
      "G3 - Content plan for the month",
      "G4 - LinkedIn post copy",
      "G5 - Set up cold email sending",
      "G6 - Build the list",
      "G7 - Launch a cold email campaign",
      "G8 - Replies — the part that matters most",
      "G9 - Daily deliverability check",
      "G10 - Ebook, white paper or report",
      "G11 - Webinar or online event",
      "G12 - Website build — we own it",
      "G13 - Monthly report",
      "F1 - Client setup — do this BEFORE any work",
      "M1 - Fractional CMO / advisory engagement",
      "M2 - Discovery and marketing audit",
      "M3 - Positioning and value proposition",
      "M4 - SEO strategy",
      "M5 - Fixing technical SEO problems",
      "M6 - Getting other sites to link to ours",
      "M7 - Refreshing old pages",
      "M8 - Being quoted in AI answers",
      "M9 - LinkedIn strategy for a person",
      "M10 - Improving a LinkedIn profile",
      "M11 - LinkedIn outbound",
      "M12 - Named account programme (ABM)",
      "M13 - SDR retainer",
      "M14 - Sales enablement asset",
      "M15 - Email programme",
      "M16 - Automatic email sequences",
      "M17 - Case study",
      "M18 - Website content and structure",
      "M19 - Website changes after launch",
      "R1 - Your weekly and monthly report (for division leads & project leads)",
    ],
  },
  {
    name: "Paid Growth",
    workCardUrl: "https://drive.google.com/file/d/1k35xDcFAtyzm79VROecdyyFDyw7jI81F/view?usp=drivesdk",
    jobs: [
      "P1 - Set up a new Meta ad account",
      "P2 - Set up a new Google Ads account",
      "P3 - Prove the tracking works — BEFORE any spend",
      "P4 - Launch a campaign",
      "P5 - Every day — 20 minutes",
      "P6 - Every week — improving it",
      "P7 - Ask for creative",
      "P8 - Testing — one thing at a time",
      "P9 - Something went wrong — PAUSE FIRST",
      "P10 - Spending more (scaling)",
      "P11 - Monthly report",
      "F1 - Client setup — BEFORE any spend",
      "M1 - Paid strategy and the numbers",
      "M2 - Audiences and exclusions",
      "M3 - Funding and budget control",
      "M4 - Tell the social team what the landing page needs",
      "M5 - Monthly account clean-up",
      "M6 - Handing an ad account back",
      "R1 - Your weekly and monthly report (for division leads & project leads)",
    ],
  },
  {
    name: "Social and Creative",
    workCardUrl: "https://drive.google.com/file/d/1IBtQOxqhVySwEbBDO9XU_L35h54_eg0U/view?usp=drivesdk",
    jobs: [
      "S1 - Single post (static)",
      "S2 - Carousel",
      "S3 - LinkedIn post",
      "S4 - Stories",
      "S5 - Publishing — read this every time",
      "S6 - Comments and messages (every day)",
      "S7 - Someone wants to buy — from a comment or DM",
      "S8 - Ad creatives for the paid team",
      "S9 - The calendar — monthly and weekly",
      "S10 - Campaign idea",
      "S11 - Brochure, PDF or deck",
      "S12 - Landing page",
      "S13 - Something wrong went live",
      "F1 - Client setup — do this BEFORE any work",
      "M1 - Social media strategy",
      "M2 - Account audit",
      "M3 - Set up and fix the accounts",
      "M4 - Write the reply rules for a client",
      "M5 - Using customer content (UGC)",
      "M6 - Getting the client's team to share posts",
      "M7 - Watching what people say (listening)",
      "M8 - Print files",
      "M9 - Email design",
      "M10 - Website build — we are the builder",
      "M11 - Looking after a live website",
      "M12 - Influencer campaign",
      "M13 - Weekly note and monthly report",
      "R1 - Your weekly and monthly report (for division leads & project leads)",
    ],
  },
  {
    name: "Design and Video",
    workCardUrl: "https://drive.google.com/file/d/1CW5JeJ4gfm4oU_0X9WjLb6I36qJtlTJi/view?usp=drivesdk",
    jobs: [
      "V1 - Reel — we shoot it",
      "V2 - Reel — client sends the footage",
      "V3 - Long video (podcast, interview)",
      "V4 - Short clips from a long video",
      "V5 - Founder / talking head video",
      "V6 - Customer story video",
      "V7 - Explainer / product video",
      "V8 - Video ads for paid campaigns",
      "V9 - Event coverage",
      "D1 - Motion graphics pack (once per brand)",
      "D2 - Photo shoot (corporate / brand)",
      "D3 - Small deliveries: thumbnails, captions, sizes, audiograms",
      "F1 - Client setup — do this BEFORE any work",
      "M1 - Build a brand identity",
      "M2 - Write the brand guidelines",
      "M3 - Lock the video style for a client",
      "M4 - Build the client word list",
      "M5 - Build the client asset folder",
      "M6 - Standalone animation (15 to 30 sec)",
      "M7 - Illustrations and icons",
      "M8 - Master templates (deck, doc)",
      "R1 - Your weekly and monthly report (for division leads & project leads)",
    ],
  },
  {
    name: "Tech and Automation",
    workCardUrl: "https://drive.google.com/file/d/1USd2bFI_7td4EYtWgHpkd5TlaB1UdqwX/view?usp=drivesdk",
    jobs: [
      "T1 - Set up tracking and prove it works",
      "T2 - Set up a CRM",
      "T3 - Connect tools together",
      "T4 - Domains, hosting and DNS",
      "T5 - Dashboards and attribution",
      "T6 - Build a custom tool or dashboard",
      "T7 - Something broke — what to do",
      "T8 - Monthly checks",
      "F1 - Client setup — before any technical work",
      "M1 - The agency data standards",
      "M2 - Access, passwords and security",
      "M3 - Technical support for a website build",
      "M4 - Handing a client's systems back",
      "R1 - Your weekly and monthly report (for division leads & project leads)",
    ],
  },
];

export const DIVISION_NAMES = DIVISIONS.map((d) => d.name);

// Jobs for a division, with "Other" always last. Unknown or empty division -> only "Other".
export const getJobsForDivision = (divisionName) => {
  const division = DIVISIONS.find((d) => d.name === divisionName);
  return [...(division ? division.jobs : []), OTHER_JOB];
};

// Work card PDF for a division (null if the division has none).
export const getWorkCardUrl = (divisionName) => {
  const division = DIVISIONS.find((d) => d.name === divisionName);
  return division ? division.workCardUrl : null;
};
